__webpack_require__.p = "/reports-new-badge-type-and-spacing/onboarding/";